import { render } from "./year.vue?vue&type=template&id=65e4bdb2&scoped=true&ts=true"
import script from "./year.vue?vue&type=script&lang=ts&config=true"
export * from "./year.vue?vue&type=script&lang=ts&config=true"

import "./year.vue?vue&type=style&index=0&id=65e4bdb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e4bdb2"]])

export default __exports__